import type { ReactNode } from 'react';
import type { CollapseProps as ReactCollapseProps } from 'react-collapse';
import { Collapse as ReactCollapse } from 'react-collapse';
import { CollapseContainer } from './Collapse.styles';

export interface CollapseProps extends Omit<ReactCollapseProps, 'isOpened' | 'children'> {
  id?: string;
  children: ReactNode;
  isCollapsed: boolean;
  /**
   * Transition duration in ms
   * @default theme.motion.duration.short
   */
  duration?: number;
}

export function Collapse({ id, children, isCollapsed, duration, ...reactCollapseProps }: CollapseProps) {
  return (
    <CollapseContainer $duration={duration} data-testid="collapse-container">
      <ReactCollapse id={id} isOpened={!isCollapsed} {...reactCollapseProps}>
        {children}
      </ReactCollapse>
    </CollapseContainer>
  );
}
